export function isQMSAdminRole(user) {
  if (!user || !Array.isArray(user.roles)) {
    return false;
  }
  return user.roles.some(role => role.name === 'QMS_ADMIN');
}

export const Permissions = user => {
  if (!user || !Array.isArray(user.roles)) {
    return undefined;
  }

  const roleNames = (user.roles || [])
    .map(role => String(role && role.name ? role.name : '').trim().toLowerCase())
    .filter(Boolean);
  let escalationMatrixRoles = [];
  try {
    escalationMatrixRoles = JSON.parse(localStorage.getItem('qms-matrix-roles') || '[]')
      .map(role => String(role || '').trim().toLowerCase())
      .filter(Boolean);
  } catch (_e) {
    escalationMatrixRoles = [];
  }
  const hasQmsEscalationRole =
    escalationMatrixRoles.length > 0 && escalationMatrixRoles.some(role => roleNames.includes(role));

  const permissions = new Set();

  // Petty Cash Team

  // const allRoles = [
  //   'ACCOUNTANT',
  //   'FINANCE_ADMIN',
  // 'SUB_ADMIN',
  //   'AREA_SALES_MANAGER',
  //   'REGIONAL_SALES_MANAGER',
  //   'QUALITY_AUDIT_MANAGER',
  //   'QUALITY_AUDIT_EXECUTIVE',
  //   'QUALITY_AUDIT_HEAD',
  //   'STORE_SALES_MANAGER',
  //   'DEPARTMENT_MANAGER',
  //   'SUPPLY_CHAIN/LP',
  //   'MARKETING',
  //   'FINANCE',
  //   'IT',
  //   'DOWNLOAD_REPORTS',
  //   'TEST_ROLE',
  //   'ADMIN'
  // ];

  const isAccountant = user.roles.filter(role => role.name === 'ACCOUNTANT');
  if (isAccountant.length) {
    ['pettyCashNavBarItemPermission', 'supportTicketsPermission', 'moreFunctionNavBarItemPermission'].forEach(p =>
      permissions.add(p)
    );
  }

  const financeAdminRole = user.roles.filter(role => role.name === 'FINANCE_ADMIN');
  if (financeAdminRole.length) {
    [
      'pettyCashNavBarItemPermission',
      'staffNavBarItemPermission',
      'userPermission',
      'storesPermission',
      'transactionComplainPermission',
      'supportTicketsPermission',
      'moreFunctionNavBarItemPermission'
    ].forEach(p => permissions.add(p));
  }

  // if asm rsm
  const ifAsmRsm = user.roles.filter(
    role => role.name === 'AREA_SALES_MANAGER' || role.name === 'REGIONAL_SALES_MANAGER'
  );
  const ifHRBP = user.roles.filter(role => role.name === 'HRBP');
  if (ifAsmRsm.length || ifHRBP.length) {
    [
      'dashboardNavBarItemPermission',
      'reportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'transactionComplainPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'staffNavBarItemPermission',
      'pettyCashNavBarItemPermission',
      'reportPermission',
      'viewChecklistPermission',
      'fillChecklistPermission',
      'popPermission',
      'osaReportPermission',
      'supportTicketsPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'tms',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }

  const foodSafetyTeam = user.roles.filter(
    role => role.name === 'QUALITY_AUDIT_MANAGER' || role.name === 'QUALITY_AUDIT_EXECUTIVE'
  );
  if (foodSafetyTeam.length) {
    [
      'reportNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'supportTicketsPermission',
      'kycPermission',
      'commentsPermission'
    ].forEach(p => permissions.add(p));
  }

  // food safety admin
  const foodSafetyAdmin = user.roles.filter(role => role.name === 'QUALITY_AUDIT_HEAD');
  if (foodSafetyAdmin.length) {
    [
      'reportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'foodSafetyPermission',
      'staffNavBarItemPermission',
      'userPermission',
      'viewFoodSafetyChecklistPermission',
      'supportTicketsPermission',
      'kycPermission',
      'commentsPermission'
    ].forEach(p => permissions.add(p));
  }

  // store sales manager
  const subAdmin = user.roles.filter(role => role.name === 'SUB_ADMIN');
  if (subAdmin.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'staffNavBarItemPermission',
      'pettyCashNavBarItemPermission',
      'transactionComplainPermission',
      'reportPermission',
      'foodSafetyPermission',
      'viewChecklistPermission',
      'viewFoodSafetyChecklistPermission',
      'fillChecklistPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'popPermission',
      'supportTicketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'eneTracker',
      'rtv',
      'tms',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }
  const isStoreSalesManager = user.roles.filter(
    role => role.name === 'STORE_SALES_MANAGER' || role.name === 'DEPARTMENT_MANAGER'
  );
  if (isStoreSalesManager.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'transactionComplainPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'pettyCashNavBarItemPermission',
      'reportPermission',
      'foodSafetyPermission',
      'fillChecklistPermission',
      'popPermission',
      'supportTicketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'userPermission',
      'eneTracker',
      'rtv',
      'tms',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }

  //  NPS USER
  const isSupply = user.roles.filter(role => role.name === 'SUPPLY_CHAIN/LP');
  const isMarketing = user.roles.filter(role => role.name === 'MARKETING');
  const isFinance = user.roles.filter(role => role.name === 'FINANCE');
  const isIT = user.roles.filter(role => role.name === 'IT');
  const isDownloadTeam = user.roles.filter(role => role.name === 'DOWNLOAD_REPORTS');
  if (isSupply.length || isMarketing.length || isFinance.length || isIT.length || isDownloadTeam.length) {
    [
      'reportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'viewChecklistPermission',
      'fillChecklistPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'npsCustomerPermission',
      'npsVenderPermission',
      'moreFunctionNavBarItemPermission',
      'popPermission',
      'supportTicketsPermission',
      'osaReportPermission',
      'kycPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'commentsPermission',
      'notesPermission',
      'storeDocumentPermission'
    ].forEach(p => permissions.add(p));
  }
  const hoViewer = user.roles.filter(role => role.name === 'HO_VIEWER');
  if (hoViewer.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'staffNavBarItemPermission',
      'transactionComplainPermission',
      'pettyCashNavBarItemPermission',
      'reportPermission',
      'foodSafetyPermission',
      'viewChecklistPermission',
      'viewFoodSafetyChecklistPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'popPermission',
      'ticketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'supportTicketsPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }
  const isCEO = user.roles.filter(role => role.name === 'CEO');
  if (isCEO.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'staffNavBarItemPermission',
      'transactionComplainPermission',
      'pettyCashNavBarItemPermission',
      'reportPermission',
      'foodSafetyPermission',
      'viewChecklistPermission',
      'viewFoodSafetyChecklistPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'popPermission',
      'supportTicketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'storesPermission',
      'rtv',
      'eneTracker'
    ].forEach(p => permissions.add(p));
  }
  // Test User
  const isTest = user.roles.filter(role => role.name === 'TEST_ROLE');
  if (isTest.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'eneTracker',
      'staffNavBarItemPermission',
      'transactionComplainPermission',
      'pettyCashNavBarItemPermission',
      'reportPermission',
      'foodSafetyPermission',
      'viewChecklistPermission',
      'viewFoodSafetyChecklistPermission',
      'fillChecklistPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'supportTicketsPermission',
      'popPermission',
      'ticketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'rolesPermission',
      'rtv',
      'tms',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }

  // Spencer Admin
  const isAdmin = user.roles.filter(role => role.name === 'ADMIN');
  if (isAdmin.length) {
    [
      'dashboardNavBarItemPermission',
      'specialReportNavBarItemPermission',
      'checklistNavBarItemPermission',
      'dynamicFormNavBarPermission',
      'eventNavBarItemPermission',
      'npsNavBarItemPermission',
      'moreFunctionNavBarItemPermission',
      'staffNavBarItemPermission',
      'pettyCashNavBarItemPermission',
      'transactionComplainPermission',
      'reportPermission',
      'foodSafetyPermission',
      'viewChecklistPermission',
      'viewFoodSafetyChecklistPermission',
      'fillChecklistPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'popPermission',
      'ticketsPermission',
      'osaReportPermission',
      'kycPermission',
      'kycInstitutionalPermission',
      'storeLicensedPermission',
      'promoCodePermission',
      'giftIssuancePermission',
      'commentsPermission',
      'notesPermission',
      'schedulesPermission',
      'tagsPermission',
      'storeDocumentPermission',
      'videosPermission',
      'userPermission',
      'rolesPermission',
      'rtv',
      'eneTracker',
      'storesPermission'
    ].forEach(p => permissions.add(p));
  }
  const isCXPulse360Admin = user.roles.filter(role => role.name === 'CUSTOMER_RELATION_MANAGER');
  if (isCXPulse360Admin.length) {
    [
      'dashboardNavBarItemPermission',
      'npsNavBarItemPermission',
      'npsVenderPermission',
      'npsCustomerPermission',
      'moreFunctionNavBarItemPermission',
      'tms'
    ].forEach(p => permissions.add(p));
  }

  const isQMSAdmin = isQMSAdminRole(user);
  if (isQMSAdmin) {
    ['qmsNavBarItemPermission', 'qmsEscalationMatrixNavBarItemPermission', 'dropdownsAdminNavBarItemPermission'].forEach(
      p => permissions.add(p)
    );
    // ensure QMS is also visible under "More Functions"
    permissions.add('qmsPermission');
    permissions.add('moreFunctionNavBarItemPermission');
  }

  if (hasQmsEscalationRole) {
    // Escalation-matrix role should be able to see QMS entry as well.
    permissions.add('qmsPermission');
    permissions.add('moreFunctionNavBarItemPermission');
  }

  return permissions.size ? Array.from(permissions) : undefined;
};
